import React, { Component } from 'react'
import CheckBox from "../../components/CheckBox"

class FilterGeographies extends Component {
  geographyChanged = (isChecked, selectedValue) => {
    this.props.onGeographyChanged(isChecked, selectedValue)
  }

  GetChildGeographies = (distinctGeographies, children) => {
    return (
      <>
        {children.length > 0 ?
          children.map(geo =>
          (
            <div key={geo.id} className='indent-item'>
              <CheckBox
                id={'cbGeography' + geo.id}
                Name={'cbGeography' + geo.id}
                Checked={this.props.selectedGeographyIds.includes(geo.id)}
                onTickChanged={(chk, val) => this.geographyChanged(chk, val)}
                Value={geo.id} text={geo.name} />

              {this.GetChildGeographies(distinctGeographies, distinctGeographies.filter(x => x.parentId === geo.id).sort((a, b) => a.name != null && b.name != null && a.name.localeCompare(b.name)))}
            </div>
          ))
          :
          null
        }
      </>
    )
  }

  render() {
    // Get distinct all geographies
    const geographies = this.props.relatedContents
      .filter(ct => ct.contentType === 4 || ct.contentType === 5 || ct.contentType === 7 || ct.contentType === 9)
      .map(content => {
        return content.categories.filter(catType => catType.type == 5 || catType.type == 6 || catType.type == 7)
      }).flat()

    const distinctGeographies = Array.from(new Set(geographies.map(cat => cat.id)))
      .map(categoryId => {
        return geographies.find(c => c.id === categoryId)
      })

    const parentGeographies = distinctGeographies.filter(x => x.parentId === 0)
      .sort((a, b) => a.name != null && b.name != null && a.name.localeCompare(b.name))

    return (
      <div className='box-inner-geographies'>
        <div className='item-sub-header'>Geography</div>
        {(parentGeographies.length > 0)
          ? <div className='item-geographies'>
            <div className='div-separator'>
              <CheckBox
                id="cbGeographiesAll"
                Name="cbGeographiesAll"
                Checked={this.props.selectedGeographyIds.length === 0}
                onTickChanged={(chk, val) => this.geographyChanged(chk, val)}
                Value='0' text='Show All'
              />
            </div>

            {parentGeographies.map(geo =>
            (
              <div key={geo.id}>
                <CheckBox
                  id={'cbGeography' + geo.id}
                  Name={'cbGeography' + geo.id}
                  Checked={this.props.selectedGeographyIds.includes(geo.id)}
                  onTickChanged={(chk, val) => this.geographyChanged(chk, val)}
                  Value={geo.id} text={geo.name} />

                {this.GetChildGeographies(distinctGeographies, distinctGeographies.filter(x => x.parentId === geo.id).sort((a, b) => a.name != null && b.name != null && a.name.localeCompare(b.name)))}
              </div>
            ))}
          </div>
          : null}
      </div>
    )
  }
}

export default FilterGeographies
